import moment from 'moment';

function formatNumber(n) {
  const str = n.toString();
  return str[1] ? str : `0${str}`;
}

function formatTime(date) {
  return moment(date).format('YYYY-MM-DD HH:mm');
}

function time2VisitTime(start, end) {
  start = moment(start);
  end = moment(end);
  const data = start.format('YYYY-MM-DD');
  return `${data} ${start.format('HH:mm')}-${end.format('HH:mm')}`;
}

//获取地址栏的参数
const getUrlParam = function(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};


export { formatNumber, formatTime, time2VisitTime, getUrlParam };
